export default function Hero() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center pt-[72px] md:pt-[80px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/30"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-accent-100/80 text-accent-700 text-xs md:text-sm font-medium px-4 py-1.5 rounded-full mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
              全网热榜 · 实时更新 · 一站聚合
            </div>

            <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl lg:text-[56px] leading-tight text-foreground-950 mb-4">
              51网址导航
              <br className="hidden sm:block" />
              <span className="text-primary-500">你的快捷上网入口</span>
              <br className="hidden sm:block" />
              与热点资讯聚合平台
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-8">
              51网址导航聚合网址导航123、123导航、导航123等数字标识快捷入口，
              每日更新全网热点事件与吃瓜资讯。不管你是想快速找到常用网站、
              追踪最新爆料，还是围观网友热评，一个首页就能搞定所有需求。
              网址123，易记好用，让上网变得更简单高效。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="font-heading font-bold text-2xl md:text-3xl text-primary-500">200+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-0.5">精选站点</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading font-bold text-2xl md:text-3xl text-primary-500">每日更新</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-0.5">热点追踪</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading font-bold text-2xl md:text-3xl text-primary-500">15</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-0.5">内容板块</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); handleNavClick('#index'); }}
                className="whitespace-nowrap w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 font-semibold px-8 py-3.5 rounded-xl hover:bg-primary-600 transition-colors duration-200 cursor-pointer text-sm md:text-base"
              >
                开始探索
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleNavClick('#ranking'); }}
                className="whitespace-nowrap w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-background-100 text-foreground-800 font-medium px-8 py-3.5 rounded-xl hover:bg-background-200 transition-colors duration-200 cursor-pointer text-sm md:text-base"
              >
                热门排行
                <i className="ri-fire-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/40 to-accent-200/30 rounded-3xl blur-xl"></div>
              <div className="relative bg-background-50 rounded-2xl p-3 md:p-4 border border-background-200/60">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20digital%20navigation%20concept%20with%20floating%20icon%20buttons%20representing%20different%20website%20categories%20on%20a%20warm%20cream%20background%2C%20clean%20geometric%20layout%2C%20soft%20ambient%20lighting%2C%20editorial%20design%20aesthetic%2C%20subtle%20warm%20orange%20and%20coral%20accent%20touches%2C%20harmonious%20composition%2C%20professional%20yet%20friendly%20feel&width=1200&height=900&seq=hero-nav-01&orientation=landscape"
                  alt="51网址导航 - 快捷上网入口聚合平台主视觉"
                  className="w-full h-auto rounded-xl object-cover"
                  width="1200"
                  height="900"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 bg-background-50 rounded-xl px-4 py-3 border border-background-200/60 flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-500 text-sm"></i>
                </div>
                <div>
                  <div className="text-xs font-semibold text-foreground-900">实时热点</div>
                  <div className="text-[10px] text-foreground-500">今日已更新 128 条</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}